import { SimpleTooltip } from "@/components/Common/Tooltip/SimpleTooltip";

export const HardwareDiscountTag = ({
  hasDiscount,
  discount,
  isPriceComparisonEnabled,
  hardwareId
}: {
  hasDiscount: boolean;
  discount: number;
  isPriceComparisonEnabled: boolean;
  hardwareId: string;
}) => {
  if (!hasDiscount) return null;

  return isPriceComparisonEnabled ? (
    <SimpleTooltip
      id={`hardware-discount-tooltip-${hardwareId}`}
      content={`This discount indicates you are saving ${discount}% compared to other providers offering the same hardware.`}
      place="top"
      tooltipClassName="max-w-[240px] whitespace-normal"
    >
      <div className="label-x-small flex-shrink-0 rounded-[4px] bg-[#00ac4d3d] px-2 py-[2px] font-medium leading-[130%] text-[#00C15D]">
        -{discount}%
      </div>
    </SimpleTooltip>
  ) : (
    <div className="label-x-small flex-shrink-0 rounded-[4px] bg-[#00ac4d3d] px-2 py-[2px] font-medium leading-[130%] text-[#00C15D]">
      -{discount}%
    </div>
  );
};
